import React from 'react';
import { hot } from 'react-hot-loader';

const Error = ({ error }) => {
	return (
		error && (
			<p className="dashboard-welcome-error" style={{ color: 'red' }}>
				{error}
			</p>
		)
	);
};

export default hot(module)(Error);
